import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ServiceAgreementRole, ServiceAgreementState } from 'ogp/services/service-agreements.types';
import { IconCancel } from 'assets/img';
import { useNavigate } from 'react-router-dom';
import { LwButton } from 'redesign';
import { routes } from 'Routes';
import { useCompanyRelativePath } from 'ogp/hooks';
import { useServiceAgreementActions } from '../../../hooks/use-service-agreement-actions';

export const ServiceAgreementDetailToolbox = ({
  serviceAgreementId,
  viewerRole,
  state,
}: {
  serviceAgreementId: string;
  viewerRole: ServiceAgreementRole;
  state: ServiceAgreementState;
}) => {
  const { t } = useTranslation('ogp-screen-specific');
  const navigate = useNavigate();
  const generatePath = useCompanyRelativePath();

  const listRoute =
    viewerRole === 'LENDER' ? routes.CollegialLendingCustomers : routes.CollegialLendingSuppliers;
  const redirectPath = generatePath(listRoute);
  const { acceptServiceAgreement, rejectServiceAgreement } =
    useServiceAgreementActions(serviceAgreementId);

  const handleClick = (action: 'accept' | 'reject') => {
    const options = {
      onSuccess: () => {
        navigate(redirectPath);
      },
    };

    if (action === 'accept') {
      acceptServiceAgreement(undefined, options);
    } else {
      rejectServiceAgreement(undefined, options);
    }
  };

  const roleSensitiveButtons =
    viewerRole === 'BORROWER' && state === 'PENDING' ? (
      <>
        <LwButton
          onClick={() => {
            handleClick('accept');
          }}
          color="primary"
        >
          {t('collegial_lending_page.service-agreement.accept')}
        </LwButton>
        <LwButton
          onClick={() => {
            handleClick('reject');
          }}
          color="primary"
        >
          {t('collegial_lending_page.service-agreement.reject')}
        </LwButton>
      </>
    ) : null;

  return (
    <>
      <Box mt={2} display="flex" flexDirection={'row'} gap={2}>
        <LwButton
          onClick={() => {
            navigate(redirectPath);
          }}
          color="secondary"
          iconColorMode="fill"
          startIcon={<IconCancel />}
        >
          {t('collegial_lending_page.service-agreement.cancel')}
        </LwButton>
        {roleSensitiveButtons}
      </Box>
    </>
  );
};
